// ESC
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let esc = get(state, 'currentContractorDetail.contractorInfo.docInfo.esc', {})
  return {
    title: i18n.gettext('ESC'),
    content: [
      {
        title: i18n.gettext('工商登记号码'),
        label: esc.num
      },
      {
        title: i18n.gettext('工商登记注册地'),
        label: esc.addr
      },
      {
        title: i18n.gettext('工商登记时间'),
        content: esc.checkDate
      },
      {
        title: i18n.gettext('执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: esc.licensePics
      }
    ]
  }
}
